module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Other Allen Drury Titles"), _c('br'), _vm._v("from WordFire")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles__And__Bold"
  }, [_c('span', [_vm._v("The Advise and Consent series")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles"
  }, [_c('span', [_vm._v("Advise and Consent")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles"
  }, [_c('span', [_vm._v("A Shade of Difference")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles"
  }, [_c('span', [_vm._v("Capable of Honor")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles"
  }, [_c('span', [_vm._v("Preserve and Protect")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles"
  }, [_c('span', [_vm._v("Come Nineveh, Come Tyre")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles"
  }, [_c('span', [_vm._v("The Promise of Joy")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles__And__14pt__And__Bold__And__No_Italic"
  }, [_c('span', [_vm._v("Other Novels")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles"
  }, [_c('span', [_vm._v("Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_OtherTitles"
  }, [_c('span', [_vm._v("Mark Coffin, U.S.S.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 63
// module chunks = 0